import React from "react";
import { node } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";

const FirmasEcheck = ({ data }) => (
    <GridTable.Container columns={3} columnsTemplate="fixed">
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="echecks.sign.documentType"
                        titleTextType="I18N"
                        valueText={data?.documento_tipo ? data?.documento_tipo : "N/A"}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="echecks.sign.documentNumber"
                    titleTextType="I18N"
                    valueText={data?.documento ? data?.documento : "N/A"}
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
    </GridTable.Container>
);

FirmasEcheck.propTypes = {
    data: node.isRequired,
};

export default FirmasEcheck;
